import React from 'react';
import './Overlays.css'

const SUIT_SYM  = { S: '♠', H: '♥', D: '♦', C: '♣' };
const SUIT_NAME = { S: 'Spades', H: 'Hearts', D: 'Diamonds', C: 'Clubs' };

export default function TrumpSelector({ gs, myId, send }) {
  const isBidWinner = gs.bid_winner === myId;
  const winnerName = gs.players?.[gs.bid_winner]?.name ?? '?';

  if (!isBidWinner) {
    return (
      <div className="phase-panel">
        <h3>Choose Trump · Thuruppu</h3>
        <p>Waiting for <strong style={{ color: '#fcd34d' }}>{winnerName}</strong> to place their trump card…</p>
      </div>
    );
  }

  return (
    <div className="phase-panel">
      <h3>Place Your Trump Card</h3>
      <p style={{ marginBottom: 8 }}>You won at <strong style={{ color: '#fcd34d' }}>{gs.current_bid}</strong>.</p>
      <div className="trump-btns">
        {['S', 'H', 'D', 'C'].map(s => (
          <button key={s} className={`trump-btn suit-${s}`} onClick={() => send('select_trump', { suit: s })}>
            <span style={{ fontSize: '2rem' }}>{SUIT_SYM[s]}</span>
            <span style={{ fontSize: '0.65rem', marginTop: 2, display: 'block' }}>{SUIT_NAME[s]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}